<template>
    <div class="wechat_order_management_wrap">
        <div class="wechat_management_top">
            <div class="wechat_management_top_search">
                <el-input size="small" v-model="keywords" placeholder="请输入订单编号/商品名称/购买人/核销人/处理人"  clearable  @clear="handleClickSearch"  @keyup.enter.native="handleClickSearch">
                    <i slot="suffix" class="el-icon-search" @click="handleClickSearch"></i>
                </el-input>
                <el-select  size="small" v-model="status"  placeholder="请选择状态" clearable  @change="handleClickSearch">
                    <el-option :value="item.value" :label="item.label" v-for="item in statusList"></el-option>
                </el-select>
                <el-select  size="small" v-model="platform_id"  placeholder="请选择购买平台" clearable @change="handleClickSearch">
                    <el-option :value="item.id" :label="item.platform_name" v-for="(item,key) in platformList" :key="key" v-if="item.is_system == 1"></el-option>
                </el-select>
            </div>
            <div class="wechat_management_top_handle">

            </div>
        </div>
        <div class="wechat_management_bottom" >
            <CustomVxeTable
                    ref="tableRef"
                    class="custom-table"
                    id="wxChatOrderTable"
                    :tableData="tableData"
                    :reduceHeight="reduceHeight"
                    :isShowToolBar="true"
                    :loading="loading"
                    :empty-render="{ name: 'NotData' }"
                    :pagination.sync="pagination"
                    @handleCurrentChange="handleCurrentChange"
                    @handleSizeChange="handleSizeChange"
                    :customConfig="tableCustomConfig">
                <vxe-column field="order_num" title="订单编号"  min-width="190" show-overflow></vxe-column>
                <vxe-column field="ticket_name" title="商品名称"  min-width="180" show-overflow>
                    <template #default="{ row }">
                       <span v-if="row.ticket_detail" v-text="row.ticket_detail.ticket_name"></span>
                    </template>
                </vxe-column>
                <vxe-column field="platform_detail" title="购买平台"  min-width="180" show-overflow>
                    <template #default="{ row }">
                        <span v-if="row.platform_detail" v-text="row.platform_detail.platform_name"></span>
                    </template>
                </vxe-column>
                <vxe-column field="user_detail" title="购买人"    min-width="180" show-overflow>
                    <template #default="{ row }">
                        <span v-if="row.user_detail" v-text="row.user_detail.phone"></span>
                    </template>

                </vxe-column>
                <vxe-column field="status" title="当前状态"  width="105" show-overflow>
                    <template #default="{ row }">
                        <!-- 状态 0=待支付 1=已支付 2=已核销 -1已取消 -2已退款 -3 退款中 -->
                        <span class="status_code status_code1"  v-if="row.status == 0 ">待支付</span>
                        <span class="status_code status_code2"  v-if="row.status == 1 ">待核销</span>
                        <span class="status_code status_code3"  v-if="row.status == 2 ">已核销</span>
                        <span class="status_code status_code4"  v-if="row.status == -1 ">已取消</span>
                        <span class="status_code status_code5"  v-if="row.status == -2 ">已退款</span>
                        <span class="status_code status_code6"  v-if="row.status == -3 ">退款中</span>
                    </template>
                </vxe-column>


                <vxe-column field="created_at" title="订单生成时间" width="140" show-overflow></vxe-column>
                <vxe-column field="pay_date" title="购买时间" width="160" show-overflow></vxe-column>
                <vxe-column field="price" title="实付金额" align="right" width="90" show-overflow>
                    <template #default="{ row }">
<!--                        已取消和待支付的不展示实付金额-->
                        <span  v-if="row.status != 0 && row.status != -1 ">{{row.price}}</span>
                    </template>
                </vxe-column>
                <vxe-column field="refund_date" title="订单退款时间"  min-width="180" show-overflow></vxe-column>
                <vxe-column field="operator_list" title="核销人/处理人"  min-width="180" show-overflow>
                    <template #default="{ row }">
                        <span v-if="(row.status == -2 || row.status == -3 ) && row.refund_user_detail"  v-text="row.refund_user_detail.name"></span>
                        <span v-else>
                            <span  v-if="row.operator_list " v-text="row.operator_list.map(item => item.name).join('、')"></span>
                        </span>
<!--                        <div class="ellipsis">-->
<!--                            <userDetailPopover :uid="item.uid" v-for="item in row.operator_list">-->
<!--                                <div slot="container">-->
<!--                                    <div class="user_head ellipsis" >-->
<!--                                        <span class="ellipsis" v-text="item.name"></span>,-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </userDetailPopover>-->
<!--                        </div>-->
                    </template>
                </vxe-column>

                <vxe-column field="operate" width="100" fixed="right">
                    <template #header>
                        <span>操作</span>
                        <el-tooltip class="item" effect="dark" content="表头设置" placement="bottom-start">
                            <i class="iconfont icon-biaotoushezhi table-header-icon" @click="handleClickCustom"></i>
                        </el-tooltip>
                    </template>
                    <template #default="{ row }">
                        <div class="table-operate-icon">
                            <el-button type="text" v-if="row.status == 1 && row.platform_id == 1" @click="handleClickRefund(row)" class="danger_text">退款</el-button>
                        </div>
                    </template>
                </vxe-column>
                <template #empty>
                    <div class="custom-table-empty">
                        <div class="custom-table-empty-img"></div>
                        <p class="custom-table-empty-txt">暂无订单</p>
                    </div>
                </template>

            </CustomVxeTable>
        </div>
    </div>
</template>
<script>
import {WxOrderList,platformList,WxOrderRefund} from "@/api/index.js"
import {pagination} from "@/mixins";
import CustomVxeTable from "@/components/pComponents/vxe-table";
import userDetailPopover from "@/components/pComponents/userDetailPopover";
export default {
    name: "wxOrderManagement",
    components: {
        CustomVxeTable,
        userDetailPopover
    },
    data() {
        return {
            keywords:'',
            loading:false,
            status:'',
            platform_id:'',
            tableData:[],
            tableCustomConfig: {
                storage:true,
                allowFixed: false,
                confirmButtonText: "确定",
                resetButtonText: "重置",
                visibleMethod: (col) => {
                    return true;
                },
                checkMethod: (col) => {
                    return col.column.field !== "id";
                },
                allowSort: true,
            },

            statusList:[
                {value:0,label:'待支付'},
                {value:1,label:'待核销'},
                {value:2,label:'已核销'},
                {value:-1,label:'已取消'},
                {value:-2,label:'已退款'},
                {value:-3,label:'退款中'},
            ],
            platformList:[]
        };
    },
    mixins: [pagination],
    computed: {
        reduceHeight() {
            return  this.tableData.length ? 218 : 172;
        },
    },
    created() {
        this.getPlatformList()
    },
    mounted() {
        this.getTableData()

    },
    methods: {
        getPlatformList(){
            platformList({}).then(res=> {
                if(res.code === 200) {
                    this.platformList = res.data
                }
            })
        },
        handleClickSearch(){
            this.getTableData()
        },
        // 表头配置
        handleClickCustom() {
            this.$refs.tableRef.handleOpenCustomShow();
        },
        handleSizeChange(val) {
            this.pagination.pageNum = 1
            this.pagination.pageSize = val.pageSize
            this.getTableData()
        },
        handleCurrentChange(val) {
            this.pagination.pageNum = val
            this.getTableData()
        },
        getTableData(){
            let postData = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword: this.keywords,
                status:this.status,
                platform_id:this.platform_id
            }
            this.loading = true
            WxOrderList(postData).then(res=> {
                if(res.code === 200) {
                    let {data,total} = res.data
                    this.tableData = data
                    this.pagination.total = total
                }
                this.loading = false
            })

        },
        // 退款
        handleClickRefund(row){
            const h = this.$createElement;
            this.$msgbox({
                title: '退款',
                message: h('div', null, [
                    h('span', null, '确定后， 实付金额将全部退还至用户'),
                ]),
                iconClass: `icon-jinggao iconfont prompt_message_icon status0`,
                customClass: 'prompt_message_custom',
                confirmButtonText:   '确定',
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                confirmButtonClass: 'el-button--danger danger',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        done();
                    } else {
                        done();
                    }
                }
            }).then(() => {
                let postData = {
                    order_id:row.id
                }

                WxOrderRefund(postData).then(res=> {
                    if(res.code === 200) {
                       this.$message.success('退款成功')
                        this.getTableData()
                    }

                })

            }).catch(() => {

            })
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/styles/wechat.scss";
</style>
